import { useTranslation } from 'react-i18next';

import type { Workspace } from '@/api/generated/schemas.ts';
import Page from '@/core/components/Page.tsx';
import TextLink from '@/core/components/TextLink.tsx';

// What a workspace's URL shows to someone whose access to it was disabled (plan task 64), instead of its pages.
const AccessDisabledPage = ({ workspace }: { workspace: Workspace }) => {
    const { t } = useTranslation();

    return (
        <Page>
            <Page.Header>
                <Page.Heading>
                    <Page.Title>{t('workspaces.accessDisabled.title')}</Page.Title>
                    <Page.Subtitle>
                        <span>{t('workspaces.accessDisabled.description', { name: workspace.name })}</span>
                        <TextLink href="/" isQuiet>
                            {t('workspaces.accessDisabled.back')} ›
                        </TextLink>
                    </Page.Subtitle>
                </Page.Heading>
            </Page.Header>
        </Page>
    );
};

export default AccessDisabledPage;
